import { useState, useEffect, useRef } from "react";

interface LazyLoadProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
  rootMargin?: string;
  minHeight?: string;
}

export const LazyLoad = ({ 
  children, 
  fallback = null, 
  rootMargin = "200px",
  minHeight = "0px"
}: LazyLoadProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let mounted = true;

    const timeoutId = setTimeout(() => {
      if (mounted) setIsVisible(true);
    }, 5000);

    // Delay observer setup to prioritize initial FCP/LCP main thread work
    const initTimer = setTimeout(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting && mounted) {
            setIsVisible(true);
            observer.disconnect();
            clearTimeout(timeoutId);
          }
        },
        { rootMargin }
      );

      if (ref.current) {
        observer.observe(ref.current);
      }
    }, 500);

    return () => {
      mounted = false;
      clearTimeout(timeoutId);
      clearTimeout(initTimer);
    };
  }, [rootMargin]);

  return (
    <div ref={ref} style={{ minHeight: isVisible ? 'auto' : minHeight }}>
      {isVisible ? children : fallback}
    </div>
  );
};
